<template>
    <div>
        <b-modal
            id="changedInstanceModal"
            ref="changedInstanceModal"
            :lazy="true"
            title="Successful Login"
            title-tag="h2"
            ok-only
            ok-title="Close"
            @hide="makeAsDefaultClinic"
        >
            <!-- Modal Form -->
            <p v-if="$root.setting.business" class="mt-2 mb-2">
                <span class="mb-4">
                    You successfully logged into the account for
                    <b v-if="$root.setting.business.instance_type == 5">{{ $root.setting.business.name }} (G)</b>
                    <b v-else>{{ $root.setting.business.name }}</b>
                </span>
                <b-form-checkbox
                    v-if="!$root.setting.isDefaultClinic"
                    v-model="isDefaultClinic"
                    id="default_clinic"
                    name="default_clinic"
                    unchecked-value="false"
                    class="mt-2"
                    plain
                >
                    <span class="fw-normal"
                        >Make <b>{{ $root.setting.business.name }}</b> my
                        default account.</span
                    >
                </b-form-checkbox>
            </p>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ChangedInstance",
    data() {
        return {
            isDefaultClinic: false
        };
    },
    mounted() {},
    methods: {
        open() {
            this._getSetting().then(() => {
                this.$refs.changedInstanceModal.show();
                this.$cookies.set("login", null, null, "/");
            });
        },
        async makeAsDefaultClinic() {
            let self = this;

            if (self.isDefaultClinic) {
                let params = {};
                await self.$http
                    .post(process.env.BARRAMUNDI + "account/default-business", {
                        params
                    })
                    .then(response => {
                        if (response) {
                            self._message("Set as default account");
                        }
                    })
                    .catch(error => {
                        self._message(
                            "Error : Unable to set as default account",
                            "danger"
                        );
                        console.error(error);
                    });
            }
        }
    }
};
</script>
